/*
 * @Description:
 * @Author: cooky
 * @Date: 2021-02-25 17:17:51
 * @LastEditors: cooky
 * @LastEditTime: 2021-03-12 09:22:56
 */
const mobileMulLangUrlConfig = {
  zh_cn: {
    title: {
      titleImg: require('@/static/assets/ui/mobile/title.png')
    }
  },
  en_us: {
    title: {
      titleImg: require('@/static/assets/ui/mobile/title-en.png')
    }
  },
  zh_tw: {
    title: {
      titleImg: require('@/static/assets/ui/mobile/title-tc.png')
    }
  }
}

export default mobileMulLangUrlConfig
